import { render, staticRenderFns } from "./SchoolSubscriptionForm.vue?vue&type=template&id=1fe5329a&scoped=true&"
import script from "./SchoolSubscriptionForm.vue?vue&type=script&lang=js&"
export * from "./SchoolSubscriptionForm.vue?vue&type=script&lang=js&"
import style0 from "./SchoolSubscriptionForm.vue?vue&type=style&index=0&id=1fe5329a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe5329a",
  null
  
)

export default component.exports